<template lang="pug">
    .residential-edit__form
        SvButton.residential-edit__button-top(
            v-show="visibleToTop"
            :prependIcon=`{
                icon: 'arrow-up',
                width: 10,
                height: 15,
            }`
            view="flat"
            text="Наверх"
            @click="scrollToTop"
        )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Активность

            .residential-edit__form-elements--small.radio
                SvRadio.residential-edit__form-radio(
                    v-model="is_active"
                    :value="true"
                    label="Да"
                )

                SvRadio.residential-edit__form-radio(
                    v-model="is_active"
                    :value="false"
                    label="Нет"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Название

            .residential-edit__form-elements--small
                SvInput(
                    v-model="name"
                    color="graylight"
                    :withIcon="false"
                    placeholder="Название ЖК"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Символьный код

            .residential-edit__form-elements--small
                SvInput(
                    v-model="alias"
                    placeholder="Например: Скидки до 80 000 рублей!"
                    color="graylight"
                    :withIcon="false"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Застройщик

            .residential-edit__form-elements--small
                SvSelect(
                    v-model="developer_id"
                    :items="getItemsDevelopers"
                    view="white"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Позиционирование

            .residential-edit__form-elements--medium
                SvInput(
                    v-model="short_description"
                    color="graylight"
                    :withIcon="false"
                    placeholder="Например: Готовый комплекс бизнес-класса в 8 минутах от метро"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Срок сдачи от

            .residential-edit__form-elements--medium.residential-edit__form-elements--flex
                SvSelect(
                    v-model="completion_deadline_from"
                    :items="getItemsCompletionDeadlines"
                    view="white"
                )

                .residential-edit__form-separator
                    | и до

                SvSelect(
                    v-model="completion_deadline_to"
                    :items="getItemsCompletionDeadlines"
                    view="white"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Район

            .residential-edit__form-elements--small
                SvSelect(
                    v-model="district_id"
                    :items="getItemsDistricts"
                    view="white"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Адрес

            .residential-edit__form-elements--small
                SvInput(
                    v-model="address"
                    color="graylight"
                    :withIcon="false"
                    placeholder="Например: Кирова 29"
                )



        .residential-edit__form-item
            span.residential-edit__form-title
                | Ориентир

            .residential-edit__form-elements--small
                SvInput(
                    v-model="landmark"
                    color="graylight"
                    placeholder="Например: в 5 минутах от пл. Клинина"
                    :withIcon="false"
                )


        .residential-edit__form-item
            span.residential-edit__form-title
                | Гео координаты

            .residential-edit__form-elements--medium.residential-edit__form-elements--flex
                SvMap(
                    v-if="geoVisible"
                    v-model="coordinates"
                    @confirm="toggleMap(false)"
                    @cancel="toggleMap(false)"
                )

                //- .residential-edit__form-elements--small
                //-     SvInput(
                //-         color="graylight"
                //-         :value="coordinatesString"
                //-         :withIcon="false"
                //-         placeholder="Геокоординаты"
                //-         @input="changeGeoPosition"
                //-     )

                        //- @input="changeCoordinateInput"
                        //- @blur="changeCoordinateBlur"


                .residential-edit__form-elements--small
                    SvInput(
                        color="graylight"
                        v-model="coordinatesString"
                        :withIcon="false"
                        placeholder="Геокоординаты"
                        :customMask="{regex: '^([-]?[0-9]{1,4})([.][0-9]{1,6})?([,] ([-]?[0-9]{1,4}))([.][0-9]{1,6})?$', placeholder: '', showMaskOnHover: false, showMaskOnFocus: false}"
                    )

                SvButton.residential-edit__link(
                    view="link"
                    text="Выбрать точку на карте"
                    @click="toggleMap(true)"
                )

        .residential-edit__form-item
            span.residential-edit__form-title.residential-edit__form-title--start
                | Преимущества объекта

            .residential-edit__form-elements--medium(
                class="residential-edit__form-elements--flex residential-edit__form-elements--grid"
            )
                SvCheckbox(
                    v-for="item in getItemsAdvantages"
                    v-model="advantages"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                )

        .residential-edit__form-item
            span.residential-edit__form-title.residential-edit__form-title--start
                | Преимущества планировок

            .residential-edit__form-elements--medium(
                class="residential-edit__form-elements--flex residential-edit__form-elements--grid"
            )
                SvCheckbox(
                    v-for="item in getItemsAdvantages"
                    v-model="layouts_advantages"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Материал дома

            .residential-edit__form-elements--medium
                SvSelectList(
                    v-model="materials"
                    :items="getItemsMaterials"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Отделка квартир

            .residential-edit__form-elements--medium
                SvSelectList(
                    v-model="decorations"
                    :items="getItemsDecorations"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Этажность

            .residential-edit__form-elements--medium
                SvInputList(
                    v-model="floors"
                    placeholder="Например: 9"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Разводка

            .residential-edit__form-elements--medium
                SvSelectList(
                    v-model="wirings"
                    :items="getItemsWirings"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Балкон

            .residential-edit__form-elements--medium
                SvSelectList(
                    v-model="balconies"
                    :items="getItemsBalconies"
                )


        .residential-edit__form-item
            span.residential-edit__form-title.residential-edit__form-title--start
                | Банки


            .residential-edit__form-elements--medium(
                class="residential-edit__form-elements--flex residential-edit__form-elements--grid"
            )
              SvCheckbox(
                      @input="handleIsManual"
                      v-model="is_manual_banks"
                      :label="'Ручной выбор банков'"
                  )


        .residential-edit__form-item
            span.residential-edit__form-title.residential-edit__form-title--start
                | Список банков

            .residential-edit__form-elements--medium(
                class="residential-edit__form-elements--flex residential-edit__form-elements--grid"
            )
                SvCheckbox(
                    v-for="item in getItemsBanks"
                    v-model="banks"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                    :disable="!is_manual_banks"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Кол-во лифтов

            .residential-edit__form-elements--medium
                SvInputList(
                    v-model="elevators"
                    placeholder="Например: 2"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Во дворе

            .residential-edit__form-elements--medium
                SvSelectList(
                    v-model="features"
                    :items="getItemsFeatures"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Во дворе (дополнительно)

            .residential-edit__form-elements--medium.ext_features
                SvInputList(
                    v-model="ext_features"
                    placeholder="Например: Мини-парк"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Рядом

            .residential-edit__form-elements--large
                SvSelectInputList(
                    v-model="infrastructures"
                    textInput="distance_in_minutes"
                    :items="getItemsInfrastructures"
                )

        .residential-edit__form-item
            span.residential-edit__form-title
                | Рядом (Дополнительно)

            .residential-edit__form-elements--large
                SvDoubleInputList(
                    v-model="ext_infrastructures"
                    firstInput="name"
                    textInput="distance_in_minutes"
                )
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import SvCheckbox from '@/components/uikit/SvCheckbox.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvMap from '@/components/uikit/SvMap.vue';
import SvSelect from '@/components/uikit/SvSelect.vue';
import SvDatePicker from '@/components/uikit/SvDatePicker.vue';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvSelectList from '@/components/uikit/SvSelectList.vue';
import SvInputList from '@/components/uikit/SvInputList.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvSelectInputList from '@/components/uikit/SvSelectInputList.vue';
import SvDoubleInputList from '@/components/uikit/SvDoubleInputList.vue';
import { rusToLatin } from '@/helpers/transform';

export default {
  name: 'FormResidentialMain',

  data() {
    return {
      geoVisible: false,
      visibleToTop: false,
      is_manual_banks: false,

      coordsStr: '',
    };
  },

  mounted() {
    window.addEventListener('scroll', () => {
      this.scrolled();
    });
  },

  watch: {
    banks(b) {
      if (b.length && !this.is_manual_banks) {
        this.is_manual_banks = true;
      }
    },
  },

  computed: {
    ...mapGetters({
      current: 'residential/getCurrent',
      getItemsAdvantages: 'getItemsAdvantages',
      getItemsBalconies: 'getItemsBalconies',
      getItemsBanks: 'getItemsBanks',
      getItemsCompletionDeadlines: 'getItemsCompletionDeadlines',
      getItemsDecorations: 'getItemsDecorations',
      getItemsDevelopers: 'getItemsDevelopers',
      getItemsDistricts: 'getItemsDistricts',
      getItemsFeatures: 'getItemsFeatures',
      getItemsInfrastructures: 'getItemsInfrastructures',
      getItemsMaterials: 'getItemsMaterials',
      getItemsRooms: 'getItemsRooms',
      getItemsWirings: 'getItemsWirings',
    }),

    coordinatesString: {
      get() {
        if (!this.coordinates) return '';
        if (this.coordsStr) {return this.coordsStr;};
        return `${(+this.coordinates.lat).toFixed(6)}, ${(+this.coordinates.lng).toFixed(6)}`;
      },
      set(value) {
        const coordinates = value.split(', ');
        this.coordsStr = value;
        this.setValue({
          latitude: coordinates[0] && (+coordinates[0]).toFixed(6) || '',
          longitude: coordinates[1] && (+coordinates[1]).toFixed(6) || ''
        });
      },
    },

    is_active: {
      get() { return this.current.is_active; },
      set(is_active) { this.setValue({ is_active }); },
    },

    name: {
      get() { return this.current.name; },
      set(name) {
        this.setValue({ name });
        this.setValue({ alias: rusToLatin(name) });
      },
    },

    alias: {
      get() { return this.current.alias; },
      set(alias) { this.setValue({ alias }); },
    },

    developer_id: {
      get() { return this.current.developer_id; },
      set(developer_id) { this.setValue({ developer_id }); },
    },

    short_description: {
      get() { return this.current.short_description; },
      set(short_description) { this.setValue({ short_description }); },
    },

    completion_deadline_from: {
      get() { return this.current.completion_deadline_from; },
      set(completion_deadline_from) { this.setValue({ completion_deadline_from }); },
    },

    completion_deadline_to: {
      get() { return this.current.completion_deadline_to; },
      set(completion_deadline_to) { this.setValue({ completion_deadline_to }); },
    },

    district_id: {
      get() { return this.current.district_id; },
      set(district_id) { this.setValue({ district_id }); },
    },

    address: {
      get() { return this.current.address; },
      set(address) { this.setValue({ address }); },
    },

    landmark: {
      get() { return this.current.landmark; },
      set(landmark) { this.setValue({ landmark }); },
    },

    coordinates: {
      get() {
        if (!this.current.latitude) return null;
        return {
          lat: this.current.latitude,
          lng: this.current.longitude,
        };
      },
      set(coordinates) {
        this.setValue({
          latitude: +coordinates.lat.toFixed(6),
          longitude: +coordinates.lng.toFixed(6),
        });
      },
    },

    advantages: {
      get() { return this.current.advantages; },
      set(advantages) { this.setValue({ advantages }); },
    },

    layouts_advantages: {
      get() { return this.current.layouts_advantages; },
      set(layouts_advantages) { this.setValue({ layouts_advantages }); },
    },

    materials: {
      get() { return this.current.materials; },
      set(materials) { this.setValue({ materials }); },
    },

    decorations: {
      get() { return this.current.decorations; },
      set(decorations) { this.setValue({ decorations }); },
    },

    floors: {
      get() { return this.current.floors; },
      set(floors) { this.setValue({ floors }); },
    },

    wirings: {
      get() { return this.current.wirings; },
      set(wirings) { this.setValue({ wirings }); },
    },

    balconies: {
      get() { return this.current.balconies; },
      set(balconies) { this.setValue({ balconies }); },
    },

    banks: {
      get() { return this.current.banks; },
      set(banks) { this.setValue({ banks }); },
    },

    elevators: {
      get() { return this.current.elevators; },
      set(elevators) { this.setValue({ elevators }); },
    },

    features: {
      get() { return this.current.features; },
      set(features) { this.setValue({ features }); },
    },

    ext_features: {
      get() { return this.current.ext_features; },
      set(ext_features) { this.setValue({ ext_features }); },
    },

    infrastructures: {
      get() { return this.current.infrastructures; },
      set(infrastructures) {
        this.setValue({ infrastructures });
      },
    },

    ext_infrastructures: {
      get() { return this.current.ext_infrastructures; },
      set(ext_infrastructures) { this.setValue({ ext_infrastructures }); },
    },
  },

  methods: {
    ...mapMutations({
      setValue: 'residential/setValue',
    }),

    handleIsManual(isManual) {
      this.is_manual_banks = isManual;
      if (!isManual) {
        this.setValue({ banks: [] });
      }
    },

    changeCoordinateBlur(value) {
      const coordinates = value.split(', ');
      this.setValue({
        latitude: coordinates[0] || '',
        longitude: coordinates[1] || '',
      });
    },

    changeCoordinateInput(value) {
        this.setValue({
               coordinatesString: value
             });
    },

    scrolled() {
      if (window.pageYOffset > 700) {
        this.visibleToTop = true;
      } else {
        this.visibleToTop = false;
      }
    },

    toggleMap(val) {
      this.geoVisible = val;
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  components: {
    SvCheckbox,
    SvDatePicker,
    SvRadio,
    SvInput,
    SvSelect,
    SvMap,
    SvButton,
    SvSelectList,
    SvInputList,
    SvSelectInputList,
    SvDoubleInputList,
  },
};
</script>

<style lang="scss">
.residential-edit__button-top {
    position: fixed;
    right: 50px;
    bottom: 50px;
    z-index: 999;
}

.residential-edit__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.residential-edit__form-title {
    display: flex;
    justify-content: flex-end;
    margin-right: 49px;
    align-items: center;

    &--start {
        align-items: flex-start;
    }
}

.residential-edit__form-item {
    display: grid;
    grid-template-columns: 291px 1fr;
    margin-top: 26px;
}

.residential-edit__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.residential-edit__form-elements--small {
    width: 311px;

    &.radio {
        display: flex;
    }
}

.residential-edit__form {
    padding: 50px 0;
}

.residential-edit__form-radio {
    margin-right: 21px;
}

.residential-edit__form-separator {
    min-width: 70px;
    text-align: center;
}

.residential-edit__form-elements--medium {
    width: 495px;

    &.ext_features {
        .sv-input__wrapper {
            width: 100%;
        }

    }
}

.residential-edit__form-elements--flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.residential-edit__form-elements--grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px 40px;
    align-items: flex-start;
    margin-bottom: 10px;

    .sv-checkbox__content {
        white-space: nowrap;
    }
}


.residential-edit__actions {
    display: flex;
    align-items: center;
    height: 100%;
}

.residential-edit__search {
    width: 47%;
    min-width: 280px;
}
</style>
